export default __webpack_public_path__ + "static/media/bscrum-logo.99b2b9ff.svg";